<!--  -->
<template>
  <div class="content">
    <div class="ban" @click="topUrl(3, '/Contact_us')">
     <img src="http://www.hitaledu.com/img/personnel.png" alt="湖南生易圈教育咨询有限公司" />
    </div>
    <!-- 平台介绍 -->
    <div class="Platform_introduction">
      <div class="card">
        <div class="left">
          <div class="Freight">Talent <br>customization <br> output</div>
          <div class="title">项目介绍</div>
          <img class="img" src="../../assets/servie/line.png" alt="湖南生易圈教育咨询有限公司" />
          <div class="info">
            <div>
                                           是一种从人才共选、联合培养，到注重企业文化导入、职业素养塑造、实操技能提升，最终实现到岗即可上手的人才培养目标的培养模式。
            </div>
            
          </div>
          <!-- <div class="bott" @click="topUrl(3, '/Contact_us')">免费试用</div> -->
        </div>
        <div class="left">
          <img src="../../assets/personnel/img.png" alt="湖南生易圈教育咨询有限公司" />
        </div>
      </div>
    </div>

    <!-- 平台模板 -->
    <div class="Platform_template">
      <Link text="培训内容" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            :class="index==1||index==3?'margin_top':''"
            v-for="(item, index) in card_list"
            :key="index"
          >
            <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
          </div>
        </div>
       
      </div>
    </div>
      <!-- 我们的过往案例 -->
    <div class="case swiper-container">
      <Link text="精选案例" />

      <div
        trigger="click"
        class="lbt swiper mySwiper"
        height="420px"
        indicator-position="outside"
      >
        <div class="list swiper-wrapper">
          <div class="li swiper-slide" v-for="(item,index) in anli_list" :key="index">
             <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.year }}</div>
              <div class="text width">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
         <div style="margin-top:20px" class="swiper-pagination"></div>
      </div>
    </div>
  
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      six_list: [
        {
          title: "线上实操",
          text: "数字化操作实现数据精准有效填写。",
          background: "url(" + require("../../assets/servie/1.png") + ")",
        },
        {
          title: "智能对比",
          text: "学生在实操录入后，系统会自动进行数据对比。",
          background: "url(" + require("../../assets/servie/2.png") + ")",
        },
        {
          title: "智能评分",
          text: "全流程记录学生实际录入操作，进行积分制，系统自动评分。",
          background: "url(" + require("../../assets/servie/3.png") + ")",
        },
        {
          title: "成绩管理",
          text: "快速查询学生实操结果，并统计所有实操信息。",
          background: "url(" + require("../../assets/servie/4.png") + ")",
        },
        {
          title: "案例管理",
          text: "老师可在丰富的案例库中挑选实操案例和上传实操案例信息。",
          background: "url(" + require("../../assets/servie/5.png") + ")",
        },
        {
          title: "学员管理",
          text: "学生可操作世界技能大赛货运代理项目比赛试题。",
          background: "url(" + require("../../assets/servie/6.png") + ")",
        },
      ],
      card_list: [
        {
          img: require("../../assets/personnel/1.png"),
          text: "案例管理",
        },
        {
          img: require("../../assets/personnel/2.png"),
          text: "现场管理",
        },
        {
          img: require("../../assets/personnel/3.png"),
          text: "报价管理",
        },
        {
          img: require("../../assets/personnel/4.png"),
          text: "单证管理",
        },
        {
          img: require("../../assets/personnel/5.png"),
          text: "操作管理",
        },
       
      ],
      price_list:[
        {
          img:require("../../assets/servie/Icon1.png"),
          title:"实训课程整体解决方案",
          text:'将企业案例带入课堂实景教学使用平台模拟真实操作满足高校专业所需',
          pric:'8000-20000',
          danwei:'元/天'
        },
         {
          img:require("../../assets/servie/Icon2.png"),
          title:"竞赛租用",
          text:'结合比赛模块进行模拟训练帮助选手熟练掌握操作技巧',
          pric:'49800',
          danwei:'元/学期'
        },
         {
          img:require("../../assets/servie/Icon3.png"),
          title:"平台采购",
          text:'根据客户需求进行定制化案例搭配提供贴合需求的售后服务',
          pric:'168000',
          danwei:'元'
        },
         {
          img:require("../../assets/servie/Icon4.png"),
          title:"定制开发",
          text:'通过院校理论支持与企业实际案例相结合，共享资源，打造专属特色软件',
          pric:'商谈',
          danwei:''
        }
      ],
       anli_list: [
        {
          img: require("../../assets/personnel/al_01.png"),
          title: "湖南省商务厅培训中心",
          year: "湖南外贸职业学院、湖南工商大学、湖南现代物流职业技术学院",
          text: "先培养后输送，以双选会的形式，让学生与企业面对面双向选择，参会企业来自湖南省各地州市外贸企业50余家。",
        },
        {
          img: require("../../assets/personnel/al_02.png"),
          title: "晟通集团",
          year: "湖南外贸职业学院",
          text: " 根据企业需求定制培训计划，理论与岗前实操相结合，对人才进行定向培养，考核通过后正式录用。",
        },
        {
          img: require("../../assets/personnel/al_03.png"),
          title: "湖南外贸职业学院",
          year: "国际经济与贸易专业现代学徒制",
          text: "校企共同制定“学徒班”岗课结合的人才培养方案、专业课程体系、管理制度以及标准体系。",
        },
       
     
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on:{
        
        }
      });
       $('#btn1').click(function(){
    alert(mySwiper.activeIndex); 
  })
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../personnel/pc);
@import url(../personnel/mod);
</style>